var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [
            _vm._v(
              "代采报表汇总: " + _vm._s(_vm.form.supply_name) + "(数量/金额)"
            )
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("\n      刷新\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  filterable: "filterable",
                                  placeholder: "选择代采组"
                                },
                                model: {
                                  value: _vm.form.pgid,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "pgid", $$v)
                                  },
                                  expression: "form.pgid"
                                }
                              },
                              _vm._l(_vm.optionsData.pg_list, function(item) {
                                return _c("el-option", {
                                  key: item.pgid,
                                  attrs: {
                                    label: item.pgname,
                                    value: item.pgid
                                  }
                                })
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "商家名称" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.supply_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "supply_name", $$v)
                                    },
                                    expression: "form.supply_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "代采单" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.woid,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "woid", $$v)
                                    },
                                    expression: "form.woid"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "款号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.goods_kh,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "goods_kh", $$v)
                                    },
                                    expression: "form.goods_kh"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "货号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.goods_no,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "goods_no", $$v)
                                    },
                                    expression: "form.goods_no"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "filterable",
                                      placeholder: "订单负责人"
                                    },
                                    model: {
                                      value: _vm.form.order_owner,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "order_owner", $$v)
                                      },
                                      expression: "form.order_owner"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-option",
                                      { attrs: { value: "", label: "" } },
                                      [_vm._v("全部")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.optionsData.owner_option,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value
                                          }
                                        })
                                      }
                                    )
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "报表状态" },
                                    model: {
                                      value: _vm.filter_table_field,
                                      callback: function($$v) {
                                        _vm.filter_table_field = $$v
                                      },
                                      expression: "filter_table_field"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { value: "0", label: "全部" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { value: "1", label: "有欠货" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { value: "2", label: "无欠货" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "含小店分发" },
                                    model: {
                                      value: _vm.form.is_dispense,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "is_dispense", $$v)
                                      },
                                      expression: "form.is_dispense"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "0" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "是", value: "1" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "否", value: "2" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      multiple: "",
                                      placeholder: "请选择商家城市"
                                    },
                                    model: {
                                      value: _vm.form.city,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "city", $$v)
                                      },
                                      expression: "form.city"
                                    }
                                  },
                                  _vm._l(
                                    _vm.optionsData.options_supply_city,
                                    function(item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    }
                                  ),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "开单时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.create_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "create_time", $$v)
                                    },
                                    expression: "form.create_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "请选择开单来源",
                                      multiple: ""
                                    },
                                    model: {
                                      value: _vm.form.source,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "source", $$v)
                                      },
                                      expression: "form.source"
                                    }
                                  },
                                  _vm._l(_vm.sources, function(item) {
                                    return _c("el-option", {
                                      key: item.key,
                                      attrs: {
                                        label: item.label,
                                        value: item.key
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "success" },
                                    on: { click: _vm.outputPart }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  导出查询数据\n                "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "success" },
                                    on: { click: _vm.outputAll }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  导出所有数据\n                "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { staticStyle: { border: "1px solid #ddd" } },
            [
              _vm.resData
                ? _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.tableLoading,
                          expression: "tableLoading"
                        }
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.resData.wcg_order_ofsupply,
                        "tooltip-effect": "dark"
                      },
                      on: { "selection-change": _vm.handleSelectionChange }
                    },
                    [
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            align: "center",
                            prop: "supply_id",
                            label: "汇总（全部）"
                          }
                        },
                        [
                          !_vm.form.order_owner
                            ? _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  prop: "supply_id",
                                  label: "商家ID"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.form.order_owner
                            ? _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  prop: "supply_name",
                                  label: "商家"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "all_num",
                              label: "实际开单"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "owe_num",
                              label: "代采欠货",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "num",
                              label: "已入库",
                              "show-overflow-tooltip": "",
                              align: "center"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "small"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.inStock(scope.row, 1)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(scope.row.num) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3781875708
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "rj_wait_receive_num",
                              label: "退换货待接收",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "rj_owe_num",
                              label: "退换欠货",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "rj_wait_stockin_num",
                              label: "退换货待入库",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "unded_num",
                              label: "待抵扣",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "use_ded_num",
                              label: "已抵扣",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "refund_num",
                              label: "已退款",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "baddebt_num",
                              label: "呆账",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "broken_num",
                              label: "代采欠货坏账",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "broken_num_rj",
                              label: "退换欠货坏账",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              { staticStyle: { "margin-bottom": "0" } },
              [
                _vm.resData
                  ? _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.resData.list.filter(function(row) {
                            if (_vm.filter_table_field) {
                              if (_vm.filter_table_field == 1) {
                                return (
                                  _vm._hasOweNum(row, "owe_num") ||
                                  _vm._hasOweNum(row, "rj_owe_num")
                                )
                              }
                              if (_vm.filter_table_field == 2) {
                                return (
                                  !_vm._hasOweNum(row, "owe_num") &&
                                  !_vm._hasOweNum(row, "rj_owe_num")
                                )
                              }
                            }
                            return true
                          }),
                          "tooltip-effect": "dark",
                          "row-class-name": _vm.tableRowClassName,
                          "cell-class-name": _vm.addBackground
                        },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: { align: "center", label: "代采订单" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("p", [_vm._v(_vm._s(scope.row.woid))]),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          color: "#2d59ec",
                                          "font-size": "14px",
                                          "line-height": "0"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              scope.row.is_dispense_label
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2474875825
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "supply_name",
                            label: "商家"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "create_time",
                            label: "时间"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "pgname",
                            label: "代采组"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "owner_admin_name",
                            label: "订单负责人"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "all_num",
                            label: "实际开单"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "owe_num",
                            label: "代采欠货",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "num",
                            label: "已入库",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "rj_wait_receive_num",
                            label: "退换货待接收",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "rj_owe_num",
                            label: "退换欠货",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "rj_wait_stockin_num",
                            label: "退换货待入库",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "unded_num",
                            label: "待抵扣",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "use_ded_num",
                            label: "已抵扣",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "refund_num",
                            label: "已退款",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "baddebt_num",
                            label: "呆账",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "broken_num",
                            label: "代采欠货坏账",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "broken_num_rj",
                            label: "退换欠货坏账",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "操作",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleClick(scope.row)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                查看详情\n              "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1231903380
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cb0ceb9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cb0ceb9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PurchaseReport.vue
// module id = null
// module chunks = 